import { ErrorBox } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { useRouteError } from "react-router-dom";

const RouterErrorBox: FC = () => {
  const err = useRouteError();
  return (
    <div className="flex flex-col flex-1 rounded-xl bg-background p-4">
      <ErrorBox error={err} />
    </div>
  );
};

export default RouterErrorBox;
